import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-txpejt",
  "use": "icon-txpejt-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" viewBox=\"0 0 15 14\" id=\"icon-txpejt\">\n<path fill-rule=\"evenodd\" fill=\"gray\" d=\"M7.197,0.000 C7.029,0.000 6.860,0.063 6.730,0.188 L0.273,6.347 C0.071,6.540 0.006,6.837 0.109,7.097 C0.212,7.357 0.463,7.528 0.741,7.528 L4.139,7.528 L4.139,13.003 C4.139,13.381 4.443,13.687 4.818,13.687 L9.576,13.687 C9.951,13.687 10.255,13.381 10.255,13.003 L10.255,7.528 L13.653,7.528 C13.931,7.528 14.182,7.357 14.285,7.097 C14.387,6.837 14.323,6.540 14.121,6.347 L7.664,0.188 C7.533,0.063 7.365,0.000 7.197,0.000 ZM2.446,6.159 L7.197,1.627 L11.948,6.159 L9.576,6.159 C9.200,6.159 8.896,6.466 8.896,6.844 L8.896,12.319 L5.498,12.319 L5.498,6.844 C5.498,6.466 5.194,6.159 4.818,6.159 L2.446,6.159 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/txpejt.svg
// module id = f112
// module chunks = 12